import { POLICY_HOLDER_LABELS, PLAN_TYPE_LABELS } from 'components/Profile/Insurance/helper';
import { getInitials } from 'utils/helpers';

const InsuranceCard = ({ data, memberName }) => {
  const { plan_type, member_id, group_number, policy_holder, insurance_company } = data || {};
  const planType = PLAN_TYPE_LABELS[plan_type] || '';
  const holder = POLICY_HOLDER_LABELS[policy_holder] || '—';
  const { title, logo_url } = insurance_company?.data?.attributes || {};

  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 shadow-xl">
      <div className="relative overflow-hidden bg-gradient-to-br from-[#3b4457] via-[#1b2130] to-[#12161f] px-6 pb-5 pt-5 shadow-[inset_0_1px_0_rgba(255,255,255,0.1)]">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_120%_80%_at_100%_0%,rgba(90,120,200,0.28),transparent_60%)]" />

        <div className="relative flex items-start justify-between gap-3">
          <div className="flex min-w-0 items-center gap-2.5">
            {(logo_url || title) &&
              <span className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-[11px] bg-white text-base font-extrabold text-teamcare-blue-dark shadow-md">
                {logo_url ? (
                  <img src={logo_url} alt={title || 'Insurance carrier'} className="h-full w-full object-cover" />
                ) : (
                  getInitials(title)
                )}
              </span>
            }
            <div className="min-w-0">
              <p className="truncate text-base font-bold tracking-[-0.01em] text-white">{title || 'None'}</p>
              <p className="mt-0.5 text-[9.5px] font-semibold uppercase tracking-[0.12em] text-white/60">Dental Plan</p>
            </div>
          </div>

          {planType && (
            <span className="inline-flex shrink-0 items-center rounded-md bg-white/[0.16] px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.08em] text-white">
              {planType}
            </span>
          )}
        </div>

        <div className="relative mt-5">
          <p className="text-[9px] font-bold uppercase tracking-[0.14em] text-white/50">Member ID</p>
          <p className="mt-1 text-[21px] font-semibold tracking-[0.18em] text-white tabular-nums">{member_id || '-'}</p>
        </div>
      </div>

      <div className="flex items-start justify-between gap-3 bg-white px-6 py-4">
        <div className="min-w-0">
          <p className="text-[8.5px] font-bold uppercase tracking-[0.12em] text-secondary-400">Member</p>
          <p className="mt-[3px] break-words text-[13px] font-semibold uppercase leading-tight text-secondary-900">{memberName || '-'}</p>
        </div>

        <div className="min-w-0">
          <p className="text-[8.5px] font-bold uppercase tracking-[0.12em] text-secondary-400">Group</p>
          <p className="mt-[3px] break-words text-[13px] font-semibold leading-tight text-secondary-900">{group_number || '-'}</p>
        </div>

        <div className="min-w-0 text-right">
          <p className="text-[8.5px] font-bold uppercase tracking-[0.12em] text-secondary-400">Holder</p>
          <p className="mt-[3px] break-words text-[13px] font-semibold leading-tight text-secondary-900">{holder || '-'}</p>
        </div>
      </div>
    </div>
  );
};

export default InsuranceCard;
